import { ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, ɵsetClassMetadata, NgModule, ɵɵdefineInjectable, Injectable, ɵɵinject, Injector } from '@angular/core';
import { HttpClientModule, HttpRequest, HttpClient, HttpParams } from '@angular/common/http';
import { of, forkJoin, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import 'reflect-metadata';

class EntityManagerModule {
    static forRoot(config) {
        return {
            ngModule: EntityManagerModule,
            providers: [config.loader]
        };
    }
}
EntityManagerModule.ɵmod = ɵɵdefineNgModule({ type: EntityManagerModule });
EntityManagerModule.ɵinj = ɵɵdefineInjector({ factory: function EntityManagerModule_Factory(t) { return new (t || EntityManagerModule)(); }, providers: [], imports: [[
            HttpClientModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(EntityManagerModule, { imports: [HttpClientModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(EntityManagerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    HttpClientModule
                ],
                providers: [],
                declarations: [],
                exports: []
            }]
    }], null, null); })();

class EntityMethodRequiredForProperty extends Error {
    constructor(entity, propertyName, methodName) {
        super(`Method of name ${methodName} not found or not public in entity
          ${entity.constructor.name}, but property name ${propertyName} is defined!`);
        Object.setPrototypeOf(this, EntityMethodRequiredForProperty.prototype);
    }
}

class EntityPropertyNotArrayButSetAsAssociationMany extends Error {
    constructor(entity, propertyName) {
        super(`Property ${propertyName} of entity ${entity} set as AssociationMany but not array passed!`);
        Object.setPrototypeOf(this, EntityPropertyNotArrayButSetAsAssociationMany.prototype);
    }
}

class Meta {
}
Meta.META = 'meta';
Meta.META_UNIQUE_ID = 'UNIQUE_ID';
Meta.IS_DIRTY = 'IS_DIRTY';
Meta.META_ROUTE = 'route';
Meta.META_ENTITY_DEFAULT_FILTERS = 'entityDefaultFilters';
Meta.META_REPOSITORY = 'repository';
Meta.META_ASSOCIATIONS = 'associations';
Meta.META_ASSOCIATIONS_MANY = 'associationsMany';
Meta.META_ASSOCIATIONS_MANY_TO_MANY = 'associationsManyToMany';
Meta.META_PROPERTY_PAYLOAD_MODIFIER = 'propertyPayloadModifier';
Meta.META_PROPERTY_RESPONSE_MODIFIER = 'propertyResponseModifier';
Meta.META_MAX_DEPTH = 'maxDepth';

class MetaPropertyNotDefined extends Error {
    constructor(constructor, propertyName) {
        super(`Meta property ${propertyName} not defined for class ${constructor.name}`);
        Object.setPrototypeOf(this, MetaPropertyNotDefined.prototype);
    }
}

class EntityManagerMetaDataService {
    createMetaData(instance) {
        instance.constructor[Meta.META] = instance.constructor[Meta.META] || {};
        return this;
    }
    hasMetaData(instance) {
        return instance.constructor[Meta.META];
    }
    hasMetaDataProperty(instance, metaProperty) {
        if (!this.hasMetaData(instance)) {
            console.error(`No meta data for instance ${instance}`);
        }
        return this.isValueNotEmpty(instance.constructor[Meta.META][metaProperty]);
    }
    getMetaDataProperty(instance, metaProperty) {
        if (!this.hasMetaDataProperty(instance, metaProperty)) {
            throw new MetaPropertyNotDefined(instance, metaProperty);
        }
        return instance.constructor[Meta.META][metaProperty];
    }
    setMetaDataProperty(instance, metaProperty, value) {
        if (!this.hasMetaData(instance)) {
            console.error(`No meta data for instance ${instance}`);
        }
        instance.constructor[Meta.META][metaProperty] = value;
        return this;
    }
    getMetaData(instance, metaProperty) {
        return instance.constructor[Meta.META][metaProperty];
    }
    isValueNotEmpty(value) {
        return typeof value !== 'undefined' && value !== null && value !== '';
    }
    getAssociation(instance, propertyKey) {
        return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS][propertyKey];
    }
    getAssociations(instance) {
        return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS];
    }
    getAssociationsMany(instance) {
        return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS_MANY];
    }
    getAssociationMany(instance, propertyKey) {
        return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS_MANY][propertyKey];
    }
    getAssociationsManyToMany(instance) {
        return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS_MANY_TO_MANY];
    }
    getAssociationManyToMany(instance, propertyKey) {
        return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS_MANY_TO_MANY][propertyKey];
    }
    getPropertyPayloadModifiers(instance) {
        return instance.constructor[Meta.META][Meta.META_PROPERTY_PAYLOAD_MODIFIER];
    }
    getPropertyResponseModifiers(instance) {
        return instance.constructor[Meta.META][Meta.META_PROPERTY_RESPONSE_MODIFIER];
    }
    hasAssociation(instance, propertyKey) {
        if (!this.hasMetaDataProperty(instance, Meta.META_ASSOCIATIONS)) {
            return false;
        }
        return typeof instance.constructor[Meta.META][Meta.META_ASSOCIATIONS][propertyKey] !== 'undefined';
    }
    hasAssociationMany(instance, propertyKey) {
        if (!this.hasMetaDataProperty(instance, Meta.META_ASSOCIATIONS_MANY)) {
            return false;
        }
        return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS_MANY][propertyKey];
    }
    hasAssociationManyToMany(instance, propertyKey) {
        if (!this.hasMetaDataProperty(instance, Meta.META_ASSOCIATIONS_MANY_TO_MANY)) {
            return false;
        }
        return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS_MANY_TO_MANY][propertyKey];
    }
}
EntityManagerMetaDataService.ɵfac = function EntityManagerMetaDataService_Factory(t) { return new (t || EntityManagerMetaDataService)(); };
EntityManagerMetaDataService.ɵprov = ɵɵdefineInjectable({ token: EntityManagerMetaDataService, factory: EntityManagerMetaDataService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EntityManagerMetaDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class EntityPropertyNotArrayButSetAsAssociationManyToMany extends Error {
    constructor(entity, propertyName) {
        super(`Property ${propertyName} of entity ${entity} set as AssociationManyToMany but not array passed!`);
        Object.setPrototypeOf(this, EntityPropertyNotArrayButSetAsAssociationManyToMany.prototype);
    }
}

class EntityPropertyModifierService {
    constructor(meta) {
        this.meta = meta;
    }
    modifyPayload(entity) {
        const modifiers = this.meta.getPropertyPayloadModifiers(entity);
        for (const modifierKey in modifiers) {
            if (modifiers.hasOwnProperty(modifierKey)) {
                this.modifyPropertyPayload(entity, modifiers[modifierKey]);
            }
        }
        return entity;
    }
    modifyResponse(entity) {
        const modifiers = this.meta.getPropertyResponseModifiers(entity);
        for (const modifierKey in modifiers) {
            if (modifiers.hasOwnProperty(modifierKey)) {
                this.modifyPropertyResponse(entity, modifiers[modifierKey]);
            }
        }
        return entity;
    }
    modifyPropertyPayload(entity, modifier) {
        const properties = modifier.properties, modifierClass = new modifier.modifier();
        for (const property in properties) {
            if (properties.hasOwnProperty(property)) {
                modifierClass.modify(property, entity, properties[property]);
            }
        }
    }
    modifyPropertyResponse(entity, modifier) {
        const properties = modifier.properties, modifierClass = new modifier.modifier();
        for (const property in properties) {
            if (properties.hasOwnProperty(property)) {
                modifierClass.modify(property, entity);
            }
        }
    }
}
EntityPropertyModifierService.ɵfac = function EntityPropertyModifierService_Factory(t) { return new (t || EntityPropertyModifierService)(ɵɵinject(EntityManagerMetaDataService)); };
EntityPropertyModifierService.ɵprov = ɵɵdefineInjectable({ token: EntityPropertyModifierService, factory: EntityPropertyModifierService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EntityPropertyModifierService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: EntityManagerMetaDataService }]; }, null); })();

class AbstractParser {
    constructor() {
        this.meta = new EntityManagerMetaDataService();
        this.propertyModifier = new EntityPropertyModifierService(this.meta);
    }
    parse(instance, data) {
        const parsed = this.parseEntity(instance, data);
        for (const propertyName of this.getPropertyNames(instance)) {
            if (this.meta.hasAssociation(instance, propertyName)) {
                this.createAssociation(instance, propertyName);
            }
            if (this.meta.hasAssociationMany(instance, propertyName)) {
                this.createAssociationMany(instance, propertyName);
            }
            if (this.meta.hasAssociationManyToMany(instance, propertyName)) {
                this.createAssociationManyToMany(instance, propertyName);
            }
        }
        this.propertyModifier.modifyResponse(instance);
        return parsed;
    }
    parseArray(instance, data) {
        const parsed = [];
        for (const entity of data) {
            parsed.push(this.parse(this.getInstance(instance.constructor), entity));
        }
        return parsed;
    }
    parseAssociationArray(associationClass, data) {
        const parsed = [];
        for (const entity of data) {
            parsed.push(this.parse(this.getInstance(associationClass), entity));
        }
        return parsed;
    }
    createAssociation(instance, propertyName) {
        const setterMethodName = this.getSetterMethodName(propertyName), getterMethodName = this.getGetterMethodName(propertyName);
        this.validatePropertyNameMethods(instance, propertyName);
        const associationClass = this.meta.getAssociation(instance, propertyName);
        if (typeof instance[propertyName] !== 'undefined' && instance[propertyName] !== null &&
            !this.isMaxDepthExcited(instance, propertyName) && typeof instance[getterMethodName]() !== 'string') {
            instance[setterMethodName](this.parse(this.getInstance(associationClass), instance[getterMethodName]()));
        }
    }
    createAssociationMany(instance, propertyName) {
        const setterMethodName = this.getSetterMethodName(propertyName), getterMethodName = this.getGetterMethodName(propertyName);
        this.validatePropertyNameMethods(instance, propertyName);
        const associationClass = this.meta.getAssociationMany(instance, propertyName);
        if (!(instance[getterMethodName]() instanceof Array)) {
            throw new EntityPropertyNotArrayButSetAsAssociationMany(instance, propertyName);
        }
        instance[setterMethodName](this.parseAssociationArray(associationClass, instance[getterMethodName]()));
    }
    createAssociationManyToMany(instance, propertyName) {
        const setterMethodName = this.getSetterMethodName(propertyName), getterMethodName = this.getGetterMethodName(propertyName);
        this.validatePropertyNameMethods(instance, propertyName);
        const associationClass = this.meta.getAssociationManyToMany(instance, propertyName);
        if (!(instance[getterMethodName]() instanceof Array)) {
            throw new EntityPropertyNotArrayButSetAsAssociationManyToMany(instance, propertyName);
        }
        instance[setterMethodName](this.parseAssociationArray(associationClass, instance[getterMethodName]()));
    }
    getSetterMethodName(propertyName) {
        propertyName = propertyName.charAt(0).toUpperCase() + propertyName.slice(1);
        return `${AbstractParser.SETTER_METHOD_PREFIX}${propertyName}`;
    }
    getGetterMethodName(propertyName) {
        propertyName = propertyName.charAt(0).toUpperCase() + propertyName.slice(1);
        return `${AbstractParser.GETTER_METHOD_PREFIX}${propertyName}`;
    }
    getPropertyNames(instance) {
        return Object.getOwnPropertyNames(instance);
    }
    getInstance(toCreate) {
        return new toCreate();
    }
    validatePropertyNameMethods(instance, propertyName) {
        const setterMethodName = this.getSetterMethodName(propertyName), getterMethodName = this.getGetterMethodName(propertyName);
        if (typeof instance[setterMethodName] !== 'function') {
            throw new EntityMethodRequiredForProperty(instance, propertyName, setterMethodName);
        }
        if (typeof instance[getterMethodName] !== 'function') {
            throw new EntityMethodRequiredForProperty(instance, propertyName, getterMethodName);
        }
    }
    isMaxDepthExcited(instance, propertyName) {
        const associationClass = this.meta.getAssociation(instance, propertyName), maxDepths = this.meta.getMetaData(instance, Meta.META_MAX_DEPTH);
        if (instance[propertyName] instanceof associationClass && maxDepths && typeof maxDepths[propertyName] !== 'undefined' &&
            typeof maxDepths[propertyName].maxDepth !== 'undefined') {
            const maxDepth = maxDepths[propertyName].maxDepth;
            maxDepths[propertyName].used++;
            if (maxDepths[propertyName].used > maxDepth) {
                return true;
            }
        }
        return false;
    }
}
AbstractParser.SETTER_METHOD_PREFIX = 'set';
AbstractParser.GETTER_METHOD_PREFIX = 'get';

class JsonParser extends AbstractParser {
    parseEntity(instance, data) {
        const parsed = Object.assign(instance, data);
        return parsed;
    }
}

class BaseConfigurator {
    constructor(urlPrefix, providers, parser) {
        this.parser = null;
        this.urlPrefix = urlPrefix;
        this.providers = providers;
        this.parser = parser || JsonParser;
    }
}
class EntityManagerConfigurator {
}

class Observables {
    constructor(observables = []) {
        this.observables = [];
        this.observables = observables;
    }
    add(observable) {
        this.observables.push(observable);
        return this;
    }
    remove(observable) {
        // todo
        return this;
    }
    getAt(index) {
        return this.observables[index];
    }
    getAll() {
        return this.observables;
    }
    count() {
        return this.observables.length;
    }
    clear() {
        this.observables = [];
        return this;
    }
}

class Guid {
    static guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
}

var State;
(function (State) {
    State[State["Create"] = 1] = "Create";
    State[State["Update"] = 2] = "Update";
    State[State["Delete"] = 3] = "Delete";
})(State || (State = {}));
class EntityManagerStateService {
    constructor(meta) {
        this.meta = meta;
        this.entities = {};
        this.init();
    }
    getAll() {
        return [].concat(this.getEntities(State.Create), this.getEntities(State.Update), this.getEntities(State.Delete));
    }
    getEntityState(entity) {
        if (this.find(State.Update, entity) !== null) {
            return State.Update;
        }
        if (this.find(State.Delete, entity) !== null) {
            return State.Delete;
        }
        return State.Create;
    }
    getEntities(state) {
        const persisted = this.entities[state] || [], entities = [];
        for (const apiRoute in persisted) {
            if (persisted[apiRoute]) {
                for (const entity of persisted[apiRoute]) {
                    entities.push(entity);
                }
            }
        }
        return entities;
    }
    persist(entity) {
        const state = entity.id ? State.Update : State.Create;
        this.prepare(state, entity)
            .addOrReplace(state, entity);
        return this;
    }
    remove(entity) {
        this.prepare(State.Delete, entity)
            .addOrReplace(State.Delete, entity);
        this.removeFromState(State.Create, entity);
        this.removeFromState(State.Update, entity);
        return this;
    }
    removeFromState(state, entity) {
        const entities = this.entities[state][entity.constructor.name] || [], index = this.findIndex(state, entity);
        entities.splice(index, 1);
        this.entities[state][entity.constructor.name] = entities;
        return this;
    }
    clear() {
        this.entities[State.Create] = {};
        this.entities[State.Update] = {};
        this.entities[State.Delete] = {};
    }
    prepare(state, entity) {
        this.entities[state][entity.constructor.name] = this.entities[state][entity.constructor.name] || [];
        return this;
    }
    addOrReplace(state, entity) {
        if (this.exists(state, entity)) {
            this.replace(state, entity);
        }
        else {
            this.add(state, entity);
        }
        return this;
    }
    add(state, entity) {
        entity[Meta.META_UNIQUE_ID] = Guid.guid();
        entity[Meta.IS_DIRTY] = true;
        this.entities[state][entity.constructor.name].push(entity);
        return this;
    }
    replace(state, entity) {
        const entities = this.entities[state][entity.constructor.name] || [], index = this.findIndex(state, entity);
        entities[index] = entity;
        this.entities[state][entity.constructor.name] = entities;
        return this;
    }
    exists(state, entity) {
        return this.find(state, entity) !== null;
    }
    find(state, entity) {
        const entities = this.entities[state][entity.constructor.name] || [];
        for (const stateEntity of entities) {
            if (stateEntity[Meta.META_UNIQUE_ID] &&
                entity[Meta.META_UNIQUE_ID] &&
                stateEntity[Meta.META_UNIQUE_ID] ===
                    entity[Meta.META_UNIQUE_ID]) {
                return stateEntity;
            }
        }
        return null;
    }
    findIndex(state, entity) {
        const entities = this.entities[state][entity.constructor.name] || [];
        let index = -1;
        if (entity.id) {
            index = entities.findIndex((aEntity) => {
                return aEntity.id === entity.id;
            });
        }
        if (entity[Meta.META_UNIQUE_ID]) {
            index = entities.findIndex((aEntity) => {
                return aEntity[Meta.META_UNIQUE_ID] === entity[Meta.META_UNIQUE_ID];
            });
        }
        return index;
    }
    init() {
        this.clear();
    }
}
EntityManagerStateService.ɵfac = function EntityManagerStateService_Factory(t) { return new (t || EntityManagerStateService)(ɵɵinject(EntityManagerMetaDataService)); };
EntityManagerStateService.ɵprov = ɵɵdefineInjectable({ token: EntityManagerStateService, factory: EntityManagerStateService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EntityManagerStateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: EntityManagerMetaDataService }]; }, null); })();

var EventType;
(function (EventType) {
    EventType[EventType["PreCreate"] = 1] = "PreCreate";
    EventType[EventType["PreUpdate"] = 2] = "PreUpdate";
    EventType[EventType["PreDelete"] = 3] = "PreDelete";
    EventType[EventType["PreRemove"] = 4] = "PreRemove";
    EventType[EventType["PrePersist"] = 5] = "PrePersist";
})(EventType || (EventType = {}));
class EntityManagerEventService {
    constructor(injector, state) {
        this.injector = injector;
        this.state = state;
        this.eventMapping = {};
        this.configuration = this.injector.get(EntityManagerConfigurator);
        this.createMapping();
    }
    run(entity, eventType) {
        const listenersTypes = this.configuration.providers || [];
        for (const listenerType of listenersTypes) {
            const listener = this.injector.get(listenerType);
            const methodName = this.createEventMethodName(eventType);
            if (typeof listener[methodName] === 'function') {
                listener[methodName](entity);
            }
        }
    }
    runPreFlush(entity = null) {
        if (entity === null) {
            this.runPreFlushEvents();
        }
        else if (entity instanceof Array) {
            for (const e of entity) {
                this.runPreFlushEvent(e);
            }
        }
        else {
            this.runPreFlushEvent(entity);
        }
        return this;
    }
    runPreFlushEvents() {
        for (const entity of this.state.getEntities(State.Create)) {
            this.run(entity, EventType.PreCreate);
        }
        for (const entity of this.state.getEntities(State.Update)) {
            this.run(entity, EventType.PreUpdate);
        }
        for (const entity of this.state.getEntities(State.Delete)) {
            this.run(entity, EventType.PreDelete);
        }
        return this;
    }
    runPreFlushEvent(entity) {
        const state = this.state.getEntityState(entity);
        if (state === State.Create) {
            this.run(entity, EventType.PreCreate);
        }
        if (state === State.Update) {
            this.run(entity, EventType.PreUpdate);
        }
        if (state === State.Delete) {
            this.run(entity, EventType.PreDelete);
        }
        return this;
    }
    createMapping() {
        this.eventMapping[EventType.PreCreate] = 'prePost';
        this.eventMapping[EventType.PreUpdate] = 'prePut';
        this.eventMapping[EventType.PreDelete] = 'preDelete';
        this.eventMapping[EventType.PreRemove] = 'preRemove';
        this.eventMapping[EventType.PrePersist] = 'prePersist';
    }
    createEventMethodName(eventType) {
        const methodPrefix = 'on', methodName = this.eventMapping[eventType];
        return methodPrefix + methodName[0].toUpperCase() + methodName.slice(1);
    }
}
EntityManagerEventService.ɵfac = function EntityManagerEventService_Factory(t) { return new (t || EntityManagerEventService)(ɵɵinject(Injector), ɵɵinject(EntityManagerStateService)); };
EntityManagerEventService.ɵprov = ɵɵdefineInjectable({ token: EntityManagerEventService, factory: EntityManagerEventService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EntityManagerEventService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Injector }, { type: EntityManagerStateService }]; }, null); })();

class EntityIdMissing extends Error {
    constructor(entity) {
        super(`ID missing in entity ${entity}!`);
        Object.setPrototypeOf(this, EntityIdMissing.prototype);
    }
}

class EntityManagerModifierService {
    constructor(injector) {
        this.injector = injector;
        this.configuration = this.injector.get(EntityManagerConfigurator);
    }
    modifyRequest(entity, request) {
        const modifiersTypes = this.configuration.providers || [];
        entity = cloneDeep(entity);
        for (const modifierType of modifiersTypes) {
            const modifier = this.injector.get(modifierType);
            if (typeof modifier.modifyRequest === 'function') {
                request = modifier.modifyRequest(entity, request);
            }
        }
        return request;
    }
    modifyResponse(entity, request, response, caller) {
        const modifiersTypes = this.configuration.providers || [];
        for (const modifierType of modifiersTypes) {
            const modifier = this.injector.get(modifierType);
            if (typeof modifier.modifyResponse === 'function') {
                response = modifier.modifyResponse(entity, request, response, caller);
            }
        }
        return response;
    }
}
EntityManagerModifierService.ɵfac = function EntityManagerModifierService_Factory(t) { return new (t || EntityManagerModifierService)(ɵɵinject(Injector)); };
EntityManagerModifierService.ɵprov = ɵɵdefineInjectable({ token: EntityManagerModifierService, factory: EntityManagerModifierService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EntityManagerModifierService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Injector }]; }, null); })();

class ParserMustDeriveFromAbstractParser extends Error {
    constructor(parser) {
        super(`${parser.constructor.name} must derive from AbstractParser!`);
        Object.setPrototypeOf(this, ParserMustDeriveFromAbstractParser.prototype);
    }
}

class EntityManagerParserService {
    constructor(injector) {
        this.injector = injector;
        this.configuration = this.injector.get(EntityManagerConfigurator);
    }
    getParser() {
        const parserType = this.configuration.parser, parser = new parserType();
        if (!(parser instanceof AbstractParser)) {
            throw new ParserMustDeriveFromAbstractParser(parser);
        }
        return parser;
    }
}
EntityManagerParserService.ɵfac = function EntityManagerParserService_Factory(t) { return new (t || EntityManagerParserService)(ɵɵinject(Injector)); };
EntityManagerParserService.ɵprov = ɵɵdefineInjectable({ token: EntityManagerParserService, factory: EntityManagerParserService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EntityManagerParserService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Injector }]; }, null); })();

class UnitOfWorkService {
    constructor(connection, state, modifier, propertyModifier, meta, parser, injector) {
        this.connection = connection;
        this.state = state;
        this.modifier = modifier;
        this.propertyModifier = propertyModifier;
        this.meta = meta;
        this.parser = parser;
        this.injector = injector;
        this.configuration = this.injector.get(EntityManagerConfigurator);
    }
    persist(entity) {
        this.state.persist(entity);
        return this;
    }
    remove(entity) {
        this.state.remove(entity);
        return this;
    }
    clear() {
        this.state.clear();
        return this;
    }
    commit(entity = null) {
        if (entity === null) {
            return this.computeChangeSets();
        }
        else if (entity instanceof Array) {
            const flush = [];
            for (const e of entity) {
                flush.push(this.computeSingleEntityChangeSet(e));
            }
            if (flush.length === 0) {
                return of([]);
            }
            return forkJoin(flush);
        }
        return this.computeSingleEntityChangeSet(entity);
    }
    computeChangeSets() {
        const flush = [];
        for (const entity of this.state.getEntities(State.Create)) {
            flush.push(this.post(entity));
        }
        for (const entity of this.state.getEntities(State.Update)) {
            flush.push(this.put(entity));
        }
        for (const entity of this.state.getEntities(State.Delete)) {
            flush.push(this.delete(entity));
        }
        if (flush.length === 0) {
            return of([]);
        }
        return new Observable(observer => {
            forkJoin(flush)
                .subscribe((flushed) => {
                this.state.clear();
                observer.next(flushed);
                observer.complete();
            });
        });
    }
    computeSingleEntityChangeSet(entity) {
        const state = this.state.getEntityState(entity);
        if (state === State.Create) {
            return this.post(entity);
        }
        if (state === State.Update) {
            return this.put(entity);
        }
        if (state === State.Delete) {
            return this.delete(entity);
        }
        return of();
    }
    post(toCreateEntity) {
        const request = this.getPostRequest(toCreateEntity);
        return this.connection
            .post(request.url, request.body, {
            headers: request.headers,
            params: request.params
        })
            .pipe(tap(() => {
            this.state.removeFromState(State.Create, toCreateEntity);
        }), map((data) => {
            return this.modifier.modifyResponse(toCreateEntity, request, data, 'post');
        }));
    }
    put(toUpdateEntity) {
        const request = this.getPutRequest(toUpdateEntity);
        return this.connection
            .put(request.url, request.body, {
            headers: request.headers,
            params: request.params
        })
            .pipe(tap(() => {
            this.state.removeFromState(State.Update, toUpdateEntity);
        }), map((data) => {
            return this.modifier.modifyResponse(toUpdateEntity, request, data, 'put');
        }));
    }
    delete(toDeleteEntity) {
        const request = this.getDeleteRequest(toDeleteEntity);
        return this.connection.delete(request.url)
            .pipe(tap(() => {
            this.state.removeFromState(State.Delete, toDeleteEntity);
        }));
    }
    getPostRequest(toCreateEntity) {
        const apiRoute = this.meta.getMetaDataProperty(toCreateEntity, Meta.META_ROUTE);
        this.propertyModifier.modifyPayload(toCreateEntity);
        return this.modifier.modifyRequest(toCreateEntity, new HttpRequest('POST', this.configuration.urlPrefix + apiRoute, toCreateEntity));
    }
    getPutRequest(toUpdateEntity) {
        const id = toUpdateEntity.id, apiRoute = this.meta.getMetaDataProperty(toUpdateEntity, Meta.META_ROUTE);
        if (!id) {
            throw new EntityIdMissing(toUpdateEntity);
        }
        this.propertyModifier.modifyPayload(toUpdateEntity);
        return this.modifier.modifyRequest(toUpdateEntity, new HttpRequest('PUT', this.configuration.urlPrefix + apiRoute + '/' + id, toUpdateEntity));
    }
    getDeleteRequest(toDeleteEntity) {
        const id = toDeleteEntity.id, apiRoute = this.meta.getMetaDataProperty(toDeleteEntity, Meta.META_ROUTE);
        if (!id) {
            throw new EntityIdMissing(toDeleteEntity);
        }
        return this.modifier.modifyRequest(toDeleteEntity, new HttpRequest('DELETE', this.configuration.urlPrefix + apiRoute + '/' + toDeleteEntity.id));
    }
}
UnitOfWorkService.ɵfac = function UnitOfWorkService_Factory(t) { return new (t || UnitOfWorkService)(ɵɵinject(HttpClient), ɵɵinject(EntityManagerStateService), ɵɵinject(EntityManagerModifierService), ɵɵinject(EntityPropertyModifierService), ɵɵinject(EntityManagerMetaDataService), ɵɵinject(EntityManagerParserService), ɵɵinject(Injector)); };
UnitOfWorkService.ɵprov = ɵɵdefineInjectable({ token: UnitOfWorkService, factory: UnitOfWorkService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UnitOfWorkService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }, { type: EntityManagerStateService }, { type: EntityManagerModifierService }, { type: EntityPropertyModifierService }, { type: EntityManagerMetaDataService }, { type: EntityManagerParserService }, { type: Injector }]; }, null); })();

class RepositoryMustDeriveFromEntityRepository extends Error {
    constructor(repository) {
        super(`${repository.constructor.name} must derive from EntityRepository!`);
        Object.setPrototypeOf(this, RepositoryMustDeriveFromEntityRepository.prototype);
    }
}

class Http {
    static objectToHttpParams(params = {}) {
        let httpParams = new HttpParams();
        for (const param in params) {
            if (params.hasOwnProperty(param)) {
                const value = params[param];
                httpParams = httpParams.set(param, value);
            }
        }
        return httpParams;
    }
}

class IdParameterMissing extends Error {
    constructor() {
        super(`ID parameter is empty!`);
        Object.setPrototypeOf(this, IdParameterMissing.prototype);
    }
}

class EntityRepository {
    constructor(connection, meta, modifier, parser, injector, entityManager) {
        this.connection = connection;
        this.meta = meta;
        this.modifier = modifier;
        this.parser = parser;
        this.injector = injector;
        this.entityManager = entityManager;
        this.configuration = this.injector.get(EntityManagerConfigurator);
    }
    find(id) {
        return this.doFind(this.entityType, id);
    }
    findOne(params) {
        return this.doFindOne(this.entityType, params);
    }
    findMore(params) {
        return this.doFindMore(this.entityType, params);
    }
    doFind(type, id) {
        if (!id) {
            throw new IdParameterMissing();
        }
        const apiRoute = this.meta.getMetaDataProperty(new type(), Meta.META_ROUTE), request = this.modifier.modifyRequest(new type(), new HttpRequest('GET', this.configuration.urlPrefix + apiRoute + '/' + id));
        return this.connection
            .get(request.url, {
            headers: request.headers,
            params: request.params
        })
            .pipe(map((data) => {
            return this.modifier.modifyResponse(new type(), new HttpRequest('GET', this.configuration.urlPrefix + apiRoute), data, 'find');
        }));
    }
    doFindOne(type, params = {}) {
        const httpParams = Http.objectToHttpParams(params);
        const apiRoute = this.meta.getMetaDataProperty(new type(), Meta.META_ROUTE), request = this.modifier.modifyRequest(new type(), new HttpRequest('GET', this.configuration.urlPrefix + apiRoute, {
            params: httpParams
        }));
        return this.connection
            .get(request.url, {
            headers: request.headers,
            params: request.params
        })
            .pipe(map((data) => {
            return this.modifier.modifyResponse(new type(), new HttpRequest('GET', this.configuration.urlPrefix + apiRoute, {
                params: httpParams
            }), data, 'findOne');
        }));
    }
    doFindMore(type, params = {}) {
        const httpParams = Http.objectToHttpParams(params);
        const apiRoute = this.meta.getMetaDataProperty(new type(), Meta.META_ROUTE), request = this.modifier.modifyRequest(new type(), new HttpRequest('GET', this.configuration.urlPrefix + apiRoute, {
            params: httpParams
        }));
        return this.connection
            .get(request.url, {
            headers: request.headers,
            params: request.params
        })
            .pipe(map((data) => {
            return this.modifier.modifyResponse(new type(), new HttpRequest('GET', this.configuration.urlPrefix + apiRoute, {
                params: httpParams
            }), data, 'findMore');
        }));
    }
}
EntityRepository.ɵfac = function EntityRepository_Factory(t) { return new (t || EntityRepository)(ɵɵinject(HttpClient), ɵɵinject(EntityManagerMetaDataService), ɵɵinject(EntityManagerModifierService), ɵɵinject(EntityManagerParserService), ɵɵinject(Injector), ɵɵinject(EntityManagerService)); };
EntityRepository.ɵprov = ɵɵdefineInjectable({ token: EntityRepository, factory: EntityRepository.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EntityRepository, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }, { type: EntityManagerMetaDataService }, { type: EntityManagerModifierService }, { type: EntityManagerParserService }, { type: Injector }, { type: EntityManagerService }]; }, null); })();

class EntityManagerRepositoryFactoryService {
    constructor(injector, meta) {
        this.injector = injector;
        this.meta = meta;
    }
    createRepository(entityType) {
        let repository = this.injector.get(EntityRepository);
        if (this.meta.hasMetaDataProperty(new entityType(), Meta.META_REPOSITORY)) {
            const entityRepository = this.meta.getMetaDataProperty(new entityType(), Meta.META_REPOSITORY);
            repository = this.injector.get(entityRepository);
        }
        if (!(repository instanceof EntityRepository)) {
            throw new RepositoryMustDeriveFromEntityRepository(repository);
        }
        repository.entityType = entityType;
        return repository;
    }
}
EntityManagerRepositoryFactoryService.ɵfac = function EntityManagerRepositoryFactoryService_Factory(t) { return new (t || EntityManagerRepositoryFactoryService)(ɵɵinject(Injector), ɵɵinject(EntityManagerMetaDataService)); };
EntityManagerRepositoryFactoryService.ɵprov = ɵɵdefineInjectable({ token: EntityManagerRepositoryFactoryService, factory: EntityManagerRepositoryFactoryService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EntityManagerRepositoryFactoryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Injector }, { type: EntityManagerMetaDataService }]; }, null); })();

class EntityManagerService {
    constructor(unitOfWorkService, event, repositoryFactory, state) {
        this.unitOfWorkService = unitOfWorkService;
        this.event = event;
        this.repositoryFactory = repositoryFactory;
        this.state = state;
        this.observables = new Observables();
    }
    persist(entity) {
        this.event.run(entity, EventType.PrePersist);
        this.unitOfWorkService.persist(entity);
        return this;
    }
    remove(entity) {
        this.event.run(entity, EventType.PreRemove);
        this.unitOfWorkService.remove(entity);
        return this;
    }
    flush(entity = null) {
        this.event.runPreFlush(entity);
        return this.unitOfWorkService.commit(entity);
    }
    getRepository(entity) {
        return this.repositoryFactory.createRepository(entity);
    }
    add(observable) {
        this.observables.add(observable);
        return this;
    }
    clear() {
        this.unitOfWorkService.clear();
        this.observables.clear();
    }
    collect() {
        return Observable.create(observer => {
            forkJoin(this.observables.getAll())
                .subscribe((observables) => {
                this.observables.clear();
                observer.next(new Observables(observables));
                observer.complete();
            });
            if (this.observables.count() === 0) {
                observer.next([]);
                observer.complete();
            }
        });
    }
}
EntityManagerService.ɵfac = function EntityManagerService_Factory(t) { return new (t || EntityManagerService)(ɵɵinject(UnitOfWorkService), ɵɵinject(EntityManagerEventService), ɵɵinject(EntityManagerRepositoryFactoryService), ɵɵinject(EntityManagerStateService)); };
EntityManagerService.ɵprov = ɵɵdefineInjectable({ token: EntityManagerService, factory: EntityManagerService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EntityManagerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: UnitOfWorkService }, { type: EntityManagerEventService }, { type: EntityManagerRepositoryFactoryService }, { type: EntityManagerStateService }]; }, null); })();

function CrossDependency(data) {
    let target = null;
    return (...args) => {
        target = args[0].prototype;
        setTimeout(() => {
            const properties = data();
            const meta = new EntityManagerMetaDataService();
            meta.createMetaData(target);
            if (!meta.hasMetaDataProperty(target, Meta.META_ASSOCIATIONS)) {
                meta.setMetaDataProperty(target, Meta.META_ASSOCIATIONS, {});
            }
            if (!meta.hasMetaDataProperty(target, Meta.META_ASSOCIATIONS_MANY)) {
                meta.setMetaDataProperty(target, Meta.META_ASSOCIATIONS_MANY, {});
            }
            if (!meta.hasMetaDataProperty(target, Meta.META_ASSOCIATIONS_MANY_TO_MANY)) {
                meta.setMetaDataProperty(target, Meta.META_ASSOCIATIONS_MANY_TO_MANY, {});
            }
            if (!meta.hasMetaDataProperty(target, Meta.META_MAX_DEPTH)) {
                meta.setMetaDataProperty(target, Meta.META_MAX_DEPTH, {});
            }
            for (const property in properties) {
                if (properties.hasOwnProperty(property)) {
                    target.constructor[Meta.META][properties[property].mapping][property] = properties[property].entity;
                    if (typeof properties[property].maxDepth !== 'undefined') {
                        target.constructor[Meta.META][Meta.META_MAX_DEPTH][property] = {
                            maxDepth: properties[property].maxDepth,
                            used: 0
                        };
                    }
                }
            }
        }, 0);
    };
}

class RouteNotDefined extends Error {
    constructor(constructor) {
        super(`Route not defined for class ${constructor.name}`);
        Object.setPrototypeOf(this, RouteNotDefined.prototype);
    }
}

function Route(route) {
    let target = null;
    return (...args) => {
        target = args[0].prototype;
        const metaService = new EntityManagerMetaDataService();
        if (target && '' === route) {
            throw new RouteNotDefined(target);
        }
        if (target) {
            metaService.createMetaData(target)
                .setMetaDataProperty(target, Meta.META_ROUTE, route);
        }
    };
}

class RepositoryNotDefined extends Error {
    constructor(constructor) {
        super(`Repository not defined for class ${constructor.name}`);
        Object.setPrototypeOf(this, RepositoryNotDefined.prototype);
    }
}

function Repository(repository) {
    let target = null;
    return (...args) => {
        target = args[0].prototype;
        const metaService = new EntityManagerMetaDataService();
        if (target && '' === repository) {
            throw new RepositoryNotDefined(target);
        }
        if (target) {
            metaService.createMetaData(target)
                .setMetaDataProperty(target, Meta.META_REPOSITORY, repository);
            ;
        }
    };
}

function AssociationOne(associatedEntity) {
    return (target, propertyKey, descriptor) => {
        const meta = new EntityManagerMetaDataService();
        meta.createMetaData(target);
        if (!meta.hasMetaDataProperty(target, Meta.META_ASSOCIATIONS)) {
            meta.setMetaDataProperty(target, Meta.META_ASSOCIATIONS, {});
        }
        target.constructor[Meta.META][Meta.META_ASSOCIATIONS][propertyKey] = associatedEntity;
    };
}

function AssociationMany(associatedEntity) {
    return (target, propertyKey, descriptor) => {
        const meta = new EntityManagerMetaDataService();
        meta.createMetaData(target);
        if (!meta.hasMetaDataProperty(target, Meta.META_ASSOCIATIONS_MANY)) {
            meta.setMetaDataProperty(target, Meta.META_ASSOCIATIONS_MANY, {});
        }
        target.constructor[Meta.META][Meta.META_ASSOCIATIONS_MANY][propertyKey] = associatedEntity;
    };
}

class Listener {
    onPrePersist(entity) { }
    onPreRemove(entity) { }
    onPreCreate(entity) { }
    onPreUpdate(Entity) { }
    onPreDelete(Entity) { }
}

class Mapper {
    map(data) {
        return data;
    }
}

/*
 * Public API Surface of entity-manager
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractParser, AssociationMany, AssociationOne, BaseConfigurator, CrossDependency, EntityManagerConfigurator, EntityManagerModule, EntityManagerParserService, EntityManagerService, EntityRepository, Listener, Mapper, Repository, Route };
//# sourceMappingURL=xcentric.js.map
